export default {
  SET_SENDERID_DATA(state, senderIdData) {
    state.senderIds = senderIdData;
  },
  SET_SENDERID_RECORDS(state, totalSenderIds) {
    state.totalSenderIds = totalSenderIds;
  },
  SET_CURRENT_PAGE(state, data) {
    state.senderIds.currentPage = data;
  },
};
